
import ProtectedAPIRepository from './ProtectedAPIRepository';
import FoCloseCasesDataMapper from '../datamapper/FoCloseCasesDataMapper';
import FoCloseCasesRM, { FoOpenRM } from '../responsemodel/FoCloseRM';
import Result from './Result';
import APIResponseModel from './APIResponseModel';

export default class FoCloseCaseRepository extends ProtectedAPIRepository {
    private foCloseDataMapper = new FoCloseCasesDataMapper();

    getFoClosedCases = async (ro?: GetFoClosedCasesRequestObject) => {
        const response = await this.post<APIResponseModel<FoCloseCasesRM>>(
            '/case/getFoCasesStatus',
            ro
        );

        if (response instanceof Result.Success) {
            const data: APIResponseModel<FoCloseCasesRM> = response.data;

            if (data.data !== null) {
                const foCloseCases = data.data.items.map((item) =>
                    this.foCloseDataMapper.map(item)
                );

                return new Result.Success({
                    totalItemCount: data.data.total_item_count,
                    items: foCloseCases,
                });
            }

            return new Result.Error(0, 'Data is null');
        }

        return response;
    };

    getFoOpenCases = async (ro?: GetFoOpenCasesRequestObject) => {
        const response = await this.post<APIResponseModel<FoOpenRM>>(
            '/case/getFoOpenCasesStatus',
            ro
        );

        if (response instanceof Result.Success) {
            const data: APIResponseModel<FoOpenRM> = response.data;

            if (data.data !== null) {
                const foOpenCases = data.data.items.map((item) =>
                    this.foCloseDataMapper.mapOpen(item)
                );

                return new Result.Success({
                    totalItemCount: data.data.total_item_count,
                    items: foOpenCases,
                });
            }

            return new Result.Error(0, 'Data is null');
        }

        return response;
    };
}

export interface FoCasesLocation {
    state?: string;
    district?: string;
}

export interface FoCasesUser {
    id: string;
    role: string;
    reportee: string[];
}

export interface GetFoClosedCasesRequestObject {
    location?: FoCasesLocation;
    user?: FoCasesUser;
    claim_number?: string;
    limit?: number;
    offset?: number;
}

export interface GetFoOpenCasesRequestObject {
    location?: FoCasesLocation;
    user?: FoCasesUser;
    claim_number?: string;
    limit?: number;
    offset?: number;
}
